import React, { Component } from 'react';
import { Router, Route, browserHistory } from 'react-router';
import {FormattedHTMLMessage} from 'react-intl';
var moment = require('moment');
import 'react-dates/initialize';
import MainContainer from '../containers/MainContainer';
import CbuContainer from '../containers/CbuContainer';
import SmsContainer from '../containers/SmsContainer';
import ProductContainer from '../containers/ProductContainer';
import AddressContainer from '../containers/AddressContainer';
import PendingContainer from '../containers/PendingContainer';
import JobInfoFormContainer from '../containers/JobInfoFormContainer';
import EmailFormContainer from '../containers/EmailFormContainer';
import ServiceInfoFormContainer from '../containers/ServiceInfoFormContainer';
import PersonalInfoFormContainer from '../containers/PersonalInfoFormContainer';
import IncomesFormContainer from '../containers/IncomesFormContainer';
import UploadFormContainer from '../containers/UploadFormContainer';
import UploadDocumentsContainer from '../containers/UploadDocumentsContainer';
import AffidavitCointainer from '../containers/AffidavitContainer';
import EmailVerificationContainer from '../containers/EmailVerificationContainer';
import Congratulations from './Congratulations';
import Rejected from './Rejected';
import Inspected from './Inspected';
import Disapproved from './Disapproved';
import CheckOut from './CheckOut';
import RenaperFaceContainer from '../containers/RenaperFaceContainer';
import RenaperDniContainer from '../containers/RenaperDniContainer';
import EmailPendingContainer from '../containers/EmailPendingContainer';
import Whatsapp from './WhatsappButton.js';
import SelfieWithDocumentContainer from '../containers/SelfieWithDocumentContainer';
import { HotKeys } from "react-hotkeys";

const keyMap = {
    SHOW_SELLER_CODE: "shift+c"
  };

var ReactGA = require('react-ga');
ReactGA.initialize('UA-131391948-1');
export { ReactGA };
moment.locale('es');

function logPageView() {
    const page = window.location.pathname + window.location.search;
    ReactGA.set({ page });
    ReactGA.pageview(page);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'virtualPageview',
        page: page
    });
}

function formatPhoneNumber(phoneNumber) {
    const rawPhone = (phoneNumber || '').toString();
    const digits = rawPhone.replace(/\D/g, '');
    if (digits.length === 10) {
        return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    return rawPhone;
}

export default class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPath: window.location.pathname
        };
    }

    componentDidMount() {
        browserHistory.listen((location) => {
            this.setState({ currentPath: location.pathname });
        });
    }

    render() {
        const isHomePage = this.state.currentPath === '/';
        const footerClass = isHomePage ? 'footer-home' : '';

        return (
            <HotKeys keyMap={keyMap}>
            <div className="App">
                <div className="pd-content">
                    <Router history={browserHistory} >
                        <Route path="/" component={MainContainer} onEnter={logPageView} />
                        <Route path="/email" component={EmailVerificationContainer} onEnter={logPageView} />
                        <Route path="/incomes" component={IncomesFormContainer} onEnter={logPageView} />
                        <Route path="/job-info" component={JobInfoFormContainer} onEnter={logPageView} />
                        <Route path="/add-email" component={EmailFormContainer} onEnter={logPageView} />
                        <Route path="/personal-info" component={PersonalInfoFormContainer} onEnter={logPageView} />
                        <Route path="/service-info" component={ServiceInfoFormContainer} onEnter={logPageView} />
                        <Route path="/uploads" component={UploadFormContainer} onEnter={logPageView} />
                        <Route path="/upload-documents" component={UploadDocumentsContainer} onEnter={logPageView} />
                        <Route path="/cbu" component={CbuContainer} onEnter={logPageView} />
                        <Route path="/renaper-face" component={RenaperFaceContainer} onEnter={logPageView} />
                        <Route path="/renaper-dni" component={RenaperDniContainer} onEnter={logPageView} />
                        <Route path="/selfie-with-document" component={SelfieWithDocumentContainer} onEnter={logPageView} />
                        <Route path="/sms" component={SmsContainer} onEnter={logPageView} />
                        <Route path="/address" component={AddressContainer} onEnter={logPageView} />
                        <Route path="/product" component={ProductContainer} onEnter={logPageView} />
                        <Route path="/pending" component={PendingContainer} onEnter={logPageView} />
                        <Route path="/email-pending" component={EmailPendingContainer} onEnter={logPageView} />
                        <Route path="/affidavit" component={AffidavitCointainer} onEnter={logPageView} />
                        <Route path="/checkout" component={CheckOut} onEnter={logPageView} />
                        <Route path="/congratulations" component={Congratulations} onEnter={logPageView} />
                        <Route path="/rejected" component={Rejected} onEnter={logPageView} />
                        <Route path="/inspected" component={Inspected} onEnter={logPageView} />
                        <Route path="/disapproved" component={Disapproved} onEnter={logPageView} />
                    </Router>
                </div>
                <Whatsapp number={process.env.REACT_APP_PHONE_NUMBER} text="Hola, tengo una consulta." gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping" gaLabel={formatPhoneNumber(process.env.PHONE_NUMBER)} />
                <footer className="pd-footer">
                <div id="footer-bottom" className={footerClass}>
                    <div className="container clearfix">
                        <div id="footer-info">
                            <FormattedHTMLMessage
                                id="app.footer-info"
                                description="Datos de la empresa" />
                        </div>
                        <div className="footer_sign">
                            <FormattedHTMLMessage
                                id="app.footer-sign"
                                description="Datos de la empresa" />
                        </div>
                    </div>
                </div>
                </footer>
            </div>
            </HotKeys>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/